import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { getPagePath, trans } from '@spotahome/soyuz/client';

import FooterBlockTitle from './components/FooterBlockTitle';
import FooterBlockList from './components/FooterBlockList';
import FooterLink from './components/FooterLink';

const LandlordFooter = ({ linkTheme }) => {
  const landlordLinks = [
    {
      url: getPagePath('externals.landlord-landing-login'),
      transKey: 'footer.item.publish_your_property'
    }
  ];

  return (
    <Fragment>
      <FooterBlockTitle text={trans('footer.label.landlords')} />
      <FooterBlockList>
        {landlordLinks.map(({ transKey, url }) => (
          <FooterLink key={transKey} linkTheme={linkTheme} href={url}>
            {trans(transKey)}
          </FooterLink>
        ))}
      </FooterBlockList>
    </Fragment>
  );
};

LandlordFooter.propTypes = {
  linkTheme: PropTypes.string.isRequired
};

export default LandlordFooter;
